import React from 'react';
import {Box} from '@mui/material';
import {useDrag} from 'react-dnd';

import {FileData} from '../types';
import {useFileContext} from '../context/FileContext';
import {scaleSize} from 'utils';
import {TILE_SIZE_INIT_VALUE} from 'const';
import {useTranslation} from 'react-i18next';
import {useFileMenuContext} from './context-menu/fileMenuContext';
import {FileFolderCard} from './FileFolderCard';

// Styles based on tile size
// const tileStyles = {
//    small: {fontSize: '0.75rem'},
//    medium: {fontSize: '1rem'},
//    large: {fontSize: '1.25rem'},
// } as const;

const tileStyles = {
   small: {width: '80px', height: '80px', fontSize: '0.75rem'},
   medium: {width: '120px', height: '120px', fontSize: '1rem'},
   large: {width: '160px', height: '160px', fontSize: '1.25rem'},
} as const;

const FileGrid: React.FC = () => {
   const {t} = useTranslation();
   const {
      sort: {sortedFiles},
      create: {openRename},
      move: {moveItem},
      downloadEncrypted,
      remove,
      loadFolder,
      selectedFiles,
      setSelectedFiles,
      tileSize,
   } = useFileContext();

   const onFileClick = async (file: FileData) => {
      if (file.type === 'folder') {
         await loadFolder(file.path);
      }
   };

   // Handle checkbox toggle
   const handleToggle = (file: FileData) => {
      const isSelected = selectedFiles.some((selected) => selected.id === file.id);
      const updatedSelection = isSelected
         ? selectedFiles.filter((selected) => selected.id !== file.id)
         : [...selectedFiles, file];
      setSelectedFiles(updatedSelection);
   };

   const {handleClick, handleClose} = useFileMenuContext();
   React.useEffect(() => handleClose, [handleClose]);

   return (
      <Box
         sx={{
            height: '65vh',
            overflowY: 'auto',
            overflowX: 'hidden',
            paddingRight: 1,
         }}
      >
         <Box
            sx={{
               display: 'grid',
               gridTemplateColumns: `repeat(auto-fill, minmax(${scaleSize(
                  150,
                  TILE_SIZE_INIT_VALUE,
                  tileSize
               )}px, 1fr))`,
               gap: 2,
            }}
         >
            {sortedFiles.map((file) => (
               <FileFolderCard file={file} key={file.name} />
            ))}
         </Box>
      </Box>
   );
};

export default FileGrid;
